import script from "./return.vue?vue&type=script&setup=true&lang=js"
export * from "./return.vue?vue&type=script&setup=true&lang=js"

import "./return.vue?vue&type=style&index=0&id=5c00a810&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c00a810"]])

export default __exports__